//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { TippyComponent as Tippy } from 'vue-tippy';
import { version } from '../../package.json';

import ViuInput from '../viu-input/viu-input.vue';
import ViuFloatingInteractive from '../viu-floating-interactive/viu-floating-interactive.vue';

export default {
  name: 'ViuSelect',
  components: {
    Tippy,
    ViuInput,
    ViuFloatingInteractive
  },
  props: {
    value: {
      type: [Number, String, Array],
      default: ''
    },
    /**
     * La lista de opciones que admite el select. Array{ value, text }
     */
    options: {
      type: Array,
      required: true
    },
    /**
     * Propiedad para definir si se va a poder seleccionar varias opciones a la vez.
     */
    /* multiselect: {
      type: Boolean,
      default: false,
    }, */
    /**
     * Dehabilita el uso del select.
     */
    disabled: Boolean,
    /**
     * Deshabilita la modificacion del select.
     */
    readOnly: Boolean,
    /**
     * Texto por defecto cuando no hay nada definido.
     */
    placeholder: {
      type: String,
      default: 'Seleccionar...'
    },
    /**
     * se establecen estilos
     * en funcion de su valor
     * y se muestra un mensaje de error
     * si es invalido
     */
    invalid: {
      type: [Boolean, String],
      default: false
    },
    /**
     * Define si sera requerido al hacer la comprobación.
     */
    required: Boolean,
    /**
     * Permitir botón de vaciar valor seleccionado
     * Por defecto => true
     */
    clearable: {
      type: Boolean,
      default: true
    },
    /**
     * Convierte el componente en un buscador con gestión externa. El valor buscado
     * se emitirá en un @search. Para cargar las posibles opciones, se deberá usar
     * el prop :options igualmente.
     * Se puede añadir un loader con el prop :loader para que realice la animación.
     * Por defecto => false
     */
    search: {
      type: Boolean,
      default: false
    },
    minSearch: {
      type: Number,
      default: 3
    },
    /**
     * Animación realizada al usar el componente como un buscador con gestión externa.
     * Por defecto => false
     */
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedOptions: this.multiselect ? [...this.value] : [this.value],
      selectedFake: '',
      optionsList: this.options,
      invalidStorage: false,
      active: false,
      closing: false,
      totalWidth: 0,
      valorCapturadoBuscador: '',
      ceroCoincidencias: false,
      ceroCoincidenciasMensaje: 'No se han encontrado coincidencias',
      events: {
        click: false,
        focus: false,
        blur: false
      },
      multiselect: false,
      blockedAction: false,
      showLoading: false,
      version
    };
  },
  computed: {
    selected() {
      let result = '';
      // if (!this.multiselect) {
      result = this.options.find(option => option.value === this.value);
      return result;
      // }
      /* result = [];
      this.options.filter(option => {
        this.value.forEach(element => {
          if (element === option.value && !option.disabled) {
            result.push(option.text);
          }
        });
        return false;
      });
      return result; */
    },
    placeholderToShow() {
      if (this.search && this.placeholder === 'Seleccionar...') {
        return 'Buscar...';
      }
      return this.placeholder;
    },
    isInvalid() {
      return this.invalid !== false || this.invalidStorage;
    },
    tippySelected() {
      const tippyArray = this.selected.slice(1);
      return tippyArray;
    },
    showInvalidReason() {
      return this.isInvalid && typeof this.invalid === 'string';
    },
    invalidReason() {
      if (typeof this.invalid === 'string') {
        return this.invalid;
      }
      return '';
    }
  },
  watch: {
    valorCapturadoBuscador() {
      if (this.search) {
        this.showLoading = true;
      }
      this.$nextTick(() => {
        this.optionsList = this.options;
        this.ceroCoincidencias = false;
        this.searching();
      });
    },
    options(valor) {
      if (this.search) {
        this.showLoading = false;
      }
      this.$nextTick(() => {
        this.optionsList = this.options;
        if (!this.multiselect && !valor.some(option => option.value === this.selectedOptions[0])) {
          this.selectedOptions = '';
        }
        if (this.multiselect) {
          this.selectedOptions = [];
        }

        if (!this.search) {
          this.ceroCoincidencias = false;
          this.active = false;
          this.closing = false;
        }
      });
    },
    value(valor) {
      if (valor.length === 0) {
        this.selectedOptions = [];
      }
      if (valor.length !== 0) {
        this.selectedOptions = this.multiselect ? [...valor] : [...[valor]];
      }
    }
  },
  created() {
    window.addEventListener('click', this.handlerFocus);
    window.addEventListener('resize', this.handlerResize);
  },
  destroyed() {
    window.removeEventListener('click', this.handlerFocus);
    window.removeEventListener('resize', this.handlerResize);
  },
  methods: {
    clearValue() {
      this.selectedOptions = [];
      this.blockedAction = false;
      this.$emit('input', '');
      /* this.$nextTick(() => {
        this.clickOverlay();
      }); */
    },
    clickOverlay() {
      if (this.blockedAction) return;
      this.events = {
        click: false,
        focus: false,
        blur: false
      };
      this.$refs.inputSearch.$refs.input.focus();
    },
    focusInput() {
      this.$nextTick(() => {
        if (this.active) {
          return;
        }
        this.valorCapturadoBuscador = '';
        this.focused('focus');
      });
    },
    /* blurInput() {
      this.$nextTick(() => {
        if (this.active && this.closing) {
          return;
        }
        this.events.blur = true;
        this.focused('blur');
      });
    }, */
    tabPress() {
      this.events.blur = true;
      this.focused('blur');
    },
    arrowPress(type) {
      if (this.loading) return;
      const key = this.optionsList.findIndex(option => option.value === this.selectedOptions[0]);
      if (type === 'up') {
        if (key === -1 && this.optionsList.length > 0) {
          this.selectedOptions = [this.optionsList[0].value];
        }
        if (key !== -1 && key !== 0 && this.optionsList.length > 0) {
          this.selectedOptions = [this.optionsList[key - 1].value];
        }
      }
      if (type === 'down') {
        if (key === -1 && this.optionsList.length > 0) {
          this.selectedOptions = [this.optionsList[0].value];
        }
        if (key !== -1 && this.optionsList.length > key + 1) {
          this.selectedOptions = [this.optionsList[key + 1].value];
        }
      }

      this.$nextTick(() => {
        setTimeout(() => {
          this.$el
            .getElementsByClassName('list-options')[0]
            .getElementsByClassName('active')[0]
            .scrollIntoView({ block: 'nearest' });
        }, 100);
      });
    },
    introInput() {
      const key = this.optionsList.findIndex(option => option.value === this.selectedOptions[0]);
      if (key !== -1 && this.optionsList[key] !== undefined) {
        this.selectOption('intro', this.optionsList[key]);
        this.closeSelect();
      }
      if (key === -1 && this.optionsList.length === 1) {
        this.selectOption('click', this.optionsList[0]);
        this.closeSelect();
      }
      if (this.search && this.optionsList[key] !== undefined) {
        this.blockedAction = true;
      }
      if (this.search && this.optionsList.length === 1 && !this.blockedAction) {
        this.blockedAction = true;
      }
    },
    deleteOption(indice) {
      this.selectedOptions.splice(indice, 1);
      this.selectedOptions.sort();
      this.$emit('input', this.selectedOptions);
    },
    searching() {
      if (this.search) {
        if (this.valorCapturadoBuscador.length > this.minSearch) {
          this.$emit('search', this.valorCapturadoBuscador);
        } else {
          this.$emit('search', '');
        }
        return;
      }
      const searchOptions = this.options.filter(opcion => {
        return opcion.text
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .includes(
            this.valorCapturadoBuscador
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
          );
      });
      if (searchOptions.length > 0) {
        this.optionsList = searchOptions;
      }

      if (searchOptions.length === 0) {
        this.ceroCoincidencias = true;
        this.optionsList = searchOptions;
      }
    },
    handlerFocus(e) {
      if (
        this.$el.querySelector('.selected-area') &&
        !this.$el.querySelector('.selected-area').contains(e.target) &&
        this.$el.querySelector('.viu-select-options') &&
        !this.$el.querySelector('.viu-select-options').contains(e.target)
      ) {
        this.closeSelect();
      }
    },
    handlerResize() {
      if (this.active) {
        this.closeSelect();
      }
    },
    focused(from) {
      if (from === 'blur') {
        this.events = {
          click: false,
          focus: false,
          blur: false
        };
        this.closeSelect();
        return;
      }
      if (from === 'focus' && this.active) {
        return;
      }
      if (from === 'focus' && !this.active && this.events.focus) {
        return;
      }
      this.events.click = true;
      this.events.focus = true;
      if (from === 'click' && this.active) {
        this.events.focus = true;
        this.$refs.inputSearch.$refs.input.focus();
      }
      if (!this.disabled && !this.readOnly) {
        let finished = false;
        if (this.active && !finished) {
          this.closeSelect();
          this.events = {
            click: false,
            focus: false,
            blur: false
          };
          finished = true;
        }
        if (!this.active && !finished) {
          const viewportOffset = this.getOffsetScreen(this.$el.querySelector('.viu-select'));
          this.totalWidth = document.body.clientWidth - viewportOffset.left;
          this.active = true;
        }
      }
    },
    closeSelect() {
      if (!this.active) {
        return;
      }
      this.events = {
        click: false,
        focus: false,
        blur: false
      };
      this.closing = true;
      setTimeout(() => {
        this.closing = false;
        this.active = false;
      }, 200);
    },
    getOffsetScreen(_el) {
      const target = _el;
      const targetWidth = target.offsetWidth;
      const targetHeight = target.offsetHeight;
      let gleft = 0;
      let gtop = 0;
      let rect = {};

      // eslint-disable-next-line consistent-return
      function moonwalk(_parent) {
        if (_parent) {
          gleft += _parent.offsetLeft;
          gtop += _parent.offsetTop;
          moonwalk(_parent.offsetParent);
        } else {
          rect = {
            top: target.offsetTop + gtop,
            left: target.offsetLeft + gleft,
            bottom: target.offsetTop + gtop + targetHeight,
            right: target.offsetLeft + gleft + targetWidth
          };
          return rect;
        }
      }
      moonwalk(target.offsetParent);
      return rect;
    },
    selectOption(mode, { value }) {
      // add values select
      if (!this.multiselect) {
        this.events = {
          click: false,
          focus: false,
          blur: false
        };

        this.closeSelect();
        if (mode === 'intro' && !this.selectedOptions.includes(this.value)) {
          this.selectedOptions = [];
          this.selectedOptions.push(value);
          this.$emit('input', value);
        }
        if (mode === 'click' && !this.selectedOptions.includes(value)) {
          this.selectedOptions = [];
          this.selectedOptions.push(value);
          this.$emit('input', value);
        }
      }

      // add & delete values multiselect
      if (this.selectedOptions.includes(value) && this.multiselect) {
        const posicion = this.selectedOptions.indexOf(value);
        this.deleteOption(posicion);
        return true;
      }

      if (!this.selectedOptions.includes(value) && this.multiselect) {
        this.selectedOptions.push(value);
        this.selectedOptions.sort();
        this.$emit('input', this.selectedOptions);
      }
      if (this.search) {
        this.blockedAction = true;
      }
      this.invalidStorage = false;
      return true;
    },
    checkInvalid() {
      const { required, selectedOptions, multiselect } = this;
      let status = false;
      let reason = '';

      this.invalidStorage = false;

      if (required && multiselect && selectedOptions.length === 0) {
        status = true;
        reason = 'Este campo es requerido';
        this.invalidStorage = status;
        return { status, reason };
      }

      if (
        required &&
        !multiselect &&
        !this.options.some(option => option.value === selectedOptions[0])
      ) {
        status = true;
        reason = 'Este campo es requerido';
        this.invalidStorage = status;
        return { status, reason };
      }

      return { status, reason };
    }
  }
};
